<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">ACESSO AO DASHBOARD</h4>
  </div>
  <div class="modal-body">
    <div>
      <mat-checkbox (change)="onCheckboxChange(!isChecked)" [checked]="isChecked">Dashboard</mat-checkbox>
    </div>
    <mat-form-field class="chip-list institution-select" appearance="outline">
      <mat-label>Instituições</mat-label>
      <mat-chip-list #chipList aria-label="Selecionar a instituição">
        <mat-chip *ngFor="let institution of selectedInstitutions" (removed)="remove(institution)">
          {{ institution }}
          <mat-icon matChipRemove>cancelar</mat-icon>
        </mat-chip>
        <input placeholder="Procurar instituição" #institutionInput [matAutocomplete]="auto"
          [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
      </mat-chip-list>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let institution of institutions" [value]="institution">
          {{ institution }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link mainFontColor" data-dismiss="modal"
      (click)="activeModal.dismiss()">Fechar</button>
    <button type="button" class="btn btn-primary mainBackground-color" (click)="save()">Aceitar</button>
  </div>
</div>
